// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/director-style.css
// module id = 1506
// module chunks = 0